import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { FileServiceService } from 'src/app/services/file-service/file-service.service';
import { DocumentService } from 'src/app/services/dataServices/document-service/document.service';
import { UtilService } from 'src/app/services/util-service/utilService';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
import { ProductCategory } from 'src/app/model/enums/productCategory';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { UserService } from 'src/app/services/user-service/userservice';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { MarketplaceService } from 'src/app/services/dataServices/marketplace-service/marketplace.service';
import { productCategoryDto } from 'src/app/model/category/productCategoryDto';
import { CategoryService } from 'src/app/services/dataServices/product-service/categoryService';
import { MinLengthErrorStateMatcher } from 'src/environments/validators';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductDetailDisplayFullComponent } from 'src/app/components/marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { AttributeValidationServiceService } from 'src/app/services/dataServices/dataValidation/attribute-validation-service/attribute-validation-service.service';
import { MatDialog } from '@angular/material/dialog';
import { NgForm, NgModel } from '@angular/forms';
import { CommonFeatureProductCreationComponent } from '../product-screen/common-feature-product-creation/common-feature-product-creation.component';
import { MatSelect } from '@angular/material/select';
import { ProductVariantVersionService } from 'src/app/services/dataServices/product-variant-version-service/product-variant-version.service';
import { Status } from 'src/app/model/enums/status';


@Component({
    selector: 'app-product-edit-screen',
    templateUrl: './product-edit-screen.component.html',
    styleUrls: [
        './product-edit-screen.component.css',
        '../../../../../app.component.css'
    ],
    standalone: false
})
export class ProductEditScreenComponent implements OnInit, OnDestroy {
    @ViewChild('form') form!: NgForm;
    @ViewChild(CommonFeatureProductCreationComponent) commonFeatureComponent!: CommonFeatureProductCreationComponent;
    @ViewChild('productCategorySelect') productCategorySelect?: MatSelect;
    @ViewChild('productURL') productURLControl?: NgModel;
    productEdit: ProductInterface;
    fetchedProduct: ProductInterface;
    public categories: productCategoryDto[] = [];
    commonFeatures: ProductCommonFeatureInterface[] = [];
    public productCategory = ProductCategory;
    isDescriptionValid = true;
    activeOrgId: string;
    subscriptionId: string;
    productNameErrorStateMatcher = new MinLengthErrorStateMatcher(160);
    selectedCategoryValue: number = null; // of type number, value for mat-select
    selectedCategory: any | null = null; // of type productCategoryDto
    private categoryChanged: boolean = false; // to track category changes
    private featureArray: string[] = [];
    versionValid: any;
    private isFormValid: boolean = false;
    features$: any | null = null;
    formTitle: string = "Produkt bearbeiten";
    private destroy$ = new Subject<void>();

    constructor(
        private dialog: MatDialog,
        public organisationService: OrganisationService,
        public attributeValidationService: AttributeValidationServiceService,
        public productService: ProductService,
        public documentService: DocumentService,
        public fileService: FileServiceService,
        public router: Router,
        private dialogService: DialogService,
        public activeRoute: ActivatedRoute,
        private commonFeatureService: CommonFeatureService,
        private userService: UserService,
        private titleService: Title,
        private stripeService: StripeService,
        private cdr: ChangeDetectorRef,
        private marketplaceService: MarketplaceService,
        private categoryService: CategoryService,
        public utilService: UtilService,
        private productVariantVersionService: ProductVariantVersionService
    ) {
        this.categories = this.categoryService.categories$.getValue();
        const defaultCategory = this.categories.find(c => c.name === 'APP'); // not in use anymore
        this.activeOrgId = this.organisationService.activeItem.organisationId?.toString();
        this.fetchedProduct = this.productService.activeItem;
        this.selectedCategory = this.categories.find(c => c.value === this.fetchedProduct.category);
        this.selectedCategoryValue = this.fetchedProduct.category;
        this.featureArray = this.fetchedProduct.features;
        this.productEdit = {
            name: this.fetchedProduct.name,
            description: this.fetchedProduct.description,
            url: this.fetchedProduct.url,
            documentFileIds: [...this.fetchedProduct.documentFileIds],
            relatedProducts: this.fetchedProduct.relatedProducts,
            id: this.fetchedProduct.id,
            productVariants: this.fetchedProduct.productVariants,
            fileId: this.fetchedProduct.fileId,
            galleryFileIds: [...this.fetchedProduct.galleryFileIds],
            slogan: this.fetchedProduct.slogan,
            features: this.fetchedProduct.features,
            category: this.fetchedProduct.category // of type number
        };

        this.productEdit.oldName = this.productEdit.name;
        this.titleService.setTitle(
            this.productEdit.name + ': Produkt bearbeiten - BIMSWARM'
        );
        this.features$ = this.commonFeatureService.getFeaturesForProduct(this.productEdit.id);
        this.commonFeatureService
            .getFeaturesForProduct(this.productEdit.id)
            .subscribe((success) => {
                this.commonFeatures = success;
                this.cdr.detectChanges();
            });
        // Reroutes to marketplace if the user is not a member of the organisation
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    private unloadHandler = (event: BeforeUnloadEvent) => {
        if (this.hasPendingChanges()) {
            event.preventDefault();
            event.returnValue = ''; // required for Chrome
        }
    };

    hasPendingChanges(): boolean {
        return this.utilService.isDirty();
    }

    // TO DO: There are two editProducts methods. Why? Can we delete one?
    createProduct(): void {
        // first variant
        let productVariant: ProductVariantInterface =
            this.productEdit.productVariants[0];
        // first version
        let productVariantVersion: VariantVersionInterface =
            productVariant.variantVersions[0];
        // validate
        //Check for string lengths
        if (
            !UtilService.areStringsValid(
                this.productEdit.name,
                this.productEdit.description,
            )
        ) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte stellen sie sicher, dass der Name oder die Beschreibung nicht zu lang sind.'
            );
            return;
        }
        if (this.productEdit.category === null || this.productEdit.category === undefined) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte wählen Sie ein Kategorie für das Produkt.'
            );
            return;
        }

        if (!UtilService.areStringsValid(productVariant.name, null)) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte stellen sie sicher, dass der Name der Variante nicht zu lang ist.'
            );
            return;
        }
        if (!UtilService.areStringsValid(productVariantVersion.name, null)) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte stellen sie sicher, dass der Name der Version nicht zu lang ist.'
            );
            return;
        }
        if (this.productEdit.fileId == null) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte wählen Sie ein Logo für das Produkt.'
            );
            return;
        }

        if (this.productEdit.description == null) {
            this.productEdit.description = '';
        }
        if (productVariant.description == null) {
            productVariant.description = '';
        }
        if (productVariantVersion.description == null) {
            productVariantVersion.description = '';
        }
        // To DO: hasAllRequiredSelections for common feature is temporarily, until a solution is found for mat-stepper validation
        if (!this.commonFeatureComponent.hasAllRequiredSelections()) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Bitte wählen Sie in Schritt 4 jeweils mindestens ein Auswahlkriterium aus.'
            );
            return;
        }

        this.productEdit.features = this.featureArray;
        this.productService.editProduct(this.productEdit).then(
            async (p: ProductInterface) => {
                await this.resetVersionsIfCategoryChanged();

                this.productService.loadProductsForOrganisation(
                    this.organisationService.activeOrganisation
                );

                this.commonFeatureService
                    .updateFeaturesForProduct(
                        p.id,
                        this.commonFeatures.map((elem) => elem.entry.id)
                    )
                    .subscribe((success) => { });

                this.router.navigateByUrl(
                    '/organisations/' +
                    this.organisationService.activeItem.organisationId +
                    '/products/' +
                    p.id
                );
                this.dialogService.openDialog(
                    'Produkt bearbeitet',
                    'Das Produkt ' +
                    p.name +
                    ' wurde erfolgreich bearbeitet.'
                );
                window.removeEventListener('beforeunload', this.unloadHandler);
                this.utilService.setDirty(false);
            },
            (e: ErrorEvent) => { }
        );
    }

    // This method is not in use 
    onSaveEdit(): void {
        this.productService.ITEM_MAP[':organisationId'] = String(
            this.organisationService.activeItem.organisationId
        );

        if (
            !UtilService.areStringsValid(
                this.productEdit.name,
                this.productEdit.description
            )
        ) {
            this.dialogService.openDialog(
                'Produkt bearbeiten fehlgeschlagen',
                'Der Name oder die Beschreibung sind zu lang.'
            );
            return;
        }

        if (this.productEdit.fileId == null) {
            this.dialogService.openDialog(
                'Produkt speichern fehlgeschlagen',
                'Bitte wählen Sie ein Logo für das Produkt.'
            );
            return;
        }

        this.productService
            .editProduct(this.productEdit)
            .then((product: ProductInterface) => {
                const url = this.router.url.replace('/edit', '');
                this.router.navigateByUrl(url);
                this.dialogService.openDialog(
                    'Produkt bearbeitet',
                    'Das Produkt ' +
                    product.name +
                    ' wurde erfolgreich bearbeitet.'
                );

                this.commonFeatureService
                    .updateFeaturesForProduct(
                        this.productEdit.id,
                        this.commonFeatures.map((elem) => elem.entry.id)
                    )
                    .subscribe((success) => {
                        // if (this.prioritizedProductChanged) {
                        //     this.prioritizeProductInStripe();
                        // }
                    });
                window.removeEventListener('beforeunload', this.unloadHandler);
                this.utilService.setDirty(false);
            })
            .catch((e: Error) => { });
    }

    onCancelEdit(): void {
        window.removeEventListener('beforeunload', this.unloadHandler);
        // auth-guards canDeactivate based on this.utilService.isDirty() === true is not in use at the moment
        // TODO: if an additional dialog is wished, setDirty() has to be removed here and a new dialog has to be implemented
        this.utilService.setDirty(false);
        this.router.navigate([
            'organisations',
            this.organisationService.activeItem.organisationId,
            'products',
            this.fetchedProduct.id
        ]);
    }

    filterOrganisationName(organisationId): string {
        return this.organisationService.collection.filter(
            (organisation) => organisation.organisationId === organisationId
        )[0].organisationName;
    }

    removeTags(descriptionText: string) {
        descriptionText = descriptionText.replace('<p>', '');
        descriptionText = descriptionText.replace('</p>', '');
        this.productEdit.description = descriptionText;
        return descriptionText.length;
    }

    /**
     * Checks wether ptgs or common features are selected and displays a dialog when changing the category
     * @param newCategory - selected category in dropdown menu
     * @returns 
     */
    setProductEditCategory(newCategory: ProductCategory): void {
        const prevValue = this.selectedCategoryValue ?? this.fetchedProduct.category ?? null; // of type number

        // checks wether ptgs were selected befor
        const hasPtgs = this.fetchedProduct.productVariants?.some(variant =>
            variant.variantVersions?.some(version =>
                Array.isArray(version.ptgVersions) && version.ptgVersions.length > 0
            )
        ) ?? false;

        // checks wether common features were selected befor
        const hasCommonFeatures = Array.isArray(this.commonFeatures) && this.commonFeatures.length > 0;

        if (!hasPtgs && !hasCommonFeatures) {
            this.applyCategoryChange(newCategory);
            return;
        }

        this.dialogService.openConfirmDialog(
            'Produktkategorie ändern',
            'Nein',
            'Ja',
            'Änderungen der Produktkategorie wirken sich auf die Auswahl der Produkttypen und übergeordneten Auswahlkriterien aus. Möchten Sie die Produktkategorie wirklich ändern?'
        ).pipe(takeUntil(this.destroy$))
            .subscribe(result => {
                if (result) {
                    this.applyCategoryChange(newCategory);
                } else {
                    this.selectedCategoryValue = prevValue;
                    this.productEdit.category = prevValue;

                    if (this.productCategorySelect) {
                        (this.productCategorySelect as any).value = prevValue;
                    }
                    this.cdr.detectChanges();
                }
            });
    }

    /**
     * Changes produt category and resets ptg selections in versions. Common feature selection is handled in component.
     * @param category - selected category in dropdown menu
     */
    private applyCategoryChange(category: any) {
        this.productEdit.category = category;
        this.selectedCategory = this.categories.find(c => c.value === category) ?? null;
        this.categoryChanged = true;

        this.cdr.detectChanges();
    }

    showCommonFeatureSelectionDialog() {
        this.dialogService
            .openCommonFeatureEditDialog([...this.commonFeatures])
            .subscribe((success) => {
                if (success) {
                    this.commonFeatures = success;
                    this.cdr.detectChanges();
                }
            });
    }

    async ngOnInit(): Promise<void> {
        window.addEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(true);
    }

    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
        window.removeEventListener('beforeunload', this.unloadHandler);
        this.utilService.setDirty(false);
        this.destroy$.next();
        this.destroy$.complete();
    }

    public onDescriptionValidityChange(descriptionValid: boolean): void {
        this.isDescriptionValid = descriptionValid;
    }

    openProductDetailsPageDialog(
        title: string
    ): Observable<any> {
        let productVariant: ProductVariantInterface = this.productEdit.productVariants[0];
        let productVariantVersion: VariantVersionInterface = this.productEdit.productVariants[0].variantVersions[0];
        if (this.productEdit.fileId == null) {
            this.productEdit.fileId = '';
        }
        if (this.productEdit.name == null) {
            this.productEdit.name = '';
        }
        if (this.productEdit.description == null) {
            this.productEdit.description = '';
        }
        if (productVariant.name == null) {
            productVariant.name = '';
        }
        if (productVariantVersion.name == null) {
            productVariantVersion.name = '';
        }
        if (productVariant.description == null) {
            productVariant.description = '';
        }
        if (productVariantVersion.description == null) {
            productVariantVersion.description = '';
        }
        //productVariantVersion.attributeValidationValues =  this.attributeValidationService.getPreviewAttributeValidationValues();
        this.productEdit.features = this.featureArray;
        const reference = this.dialog.open(ProductDetailDisplayFullComponent, {
            width: '95vw',
            maxWidth: '95vw',
            height: '90vh',
            data: {
                title: 'Produktübersicht',
                product: this.productEdit,
                preview: true,
                commonFeatures: this.commonFeatures
            }
        });
        return reference.afterClosed();
    }

    onCommonFeaturesChanged(features: ProductCommonFeatureInterface[]): void {
        this.commonFeatures = features;
    }

    isSaveDisabled(): boolean {
        return (
            this.form?.status != 'VALID' ||
            !this.isDescriptionValid ||
            this.productEdit.fileId === null ||
            this.productEdit.category === '' ||
            this.productEdit.category === null
        )
    }

    public onValidityChanged(valid: boolean): void {
        this.isFormValid = valid;
        this.versionValid = valid;
    }

    isDetailsStepComplete(): boolean {
        const hasBasicData  = !!this.productEdit?.name &&
            this.productEdit.name.trim().length > 0 &&
            this.productEdit.category !== null &&
            this.productEdit.category !== '' &&
            this.productEdit.url !== null &&
            this.productEdit.url !== '';

        const isProductNameValid = !!this.productEdit?.name && this.productEdit.name.length <= 160 && this.productEdit.name.length > 1;
        const isUrlValid = this.productURLControl?.valid ?? false;
        const isDescriptionValid = this.isDescriptionValid;

        return hasBasicData && isProductNameValid && isUrlValid && isDescriptionValid;
    }

    isGalleryStepComplete(): boolean {
        const hasFile = !!this.productEdit?.fileId;
        return hasFile;
    }

    public isCommonFeatureStepValid(): boolean {
        if (!this.commonFeatureComponent) return false;
        return this.commonFeatureComponent.hasAllRequiredSelections();
    }

    private mapToVersionUpdateDto(version: VariantVersionInterface) {
        return {
            id: version.id ?? null,
            name: version.name ?? null,
            description: version.description ?? null,
            comment: version.comment ?? null,
            status: version.status ?? Status.ACTIVE,
            keywords: version.keywords ?? [],
            attributeValidationValues: {}, // delete PTG related info
            previousVersion: version.previousVersion ?? null,
            ptgVersionIds: [],            // delete PTG related info
            ptgVersions: [],              // delete PTG related info
            productTypeNames: [],         // delete PTG related info
            productVariantId: version.productVariantId ?? null
        };
    }

    /**
     * Methode to delete all ptg selections in all versions of the product when the category has been changed
     * @returns 
     */
    private async resetVersionsIfCategoryChanged(): Promise<void> {
        if (!this.categoryChanged || this.productEdit.category === this.fetchedProduct.category) return;

        const promises: Promise<any>[] = [];

        if (this.productEdit.productVariants) {
            for (const variant of this.productEdit.productVariants) {
                if (variant.variantVersions) {
                    for (const version of variant.variantVersions) {
                        const updateDto = this.mapToVersionUpdateDto(version);
                        const p = this.productVariantVersionService.putItem(updateDto)
                            .then(updated => {
                                console.log('Version aktualisiert:', updated.id);
                            })
                            .catch(err => {
                                console.error('Fehler beim Zurücksetzen der Version: ', version.id, err);
                                this.dialogService.openDialog(
                                    'Fehler',
                                    'Eine Version konnte nicht aktualisiert werden.'
                                );
                            });
                        promises.push(p);
                    }
                }
            }
        }

        await Promise.all(promises);
        this.categoryChanged = false;
    }

}
